"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicBrandInfo", {
  enumerable: true,
  get: function get() {
    return _usePrismicBrandInfo["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicBrandInfo = _interopRequireDefault(require("./usePrismicBrandInfo"));
var _fetcher = _interopRequireDefault(require("./fetcher"));